import React, { useCallback } from 'react';
import { Redirect, RouteComponentProps } from 'react-router';
import { checkIsMarketMultilingual, LanguageCode, MarketCode } from '@tink/config/src/markets';
import { LegalTemplate } from '../organisms/LegalTemplate/LegalTemplate';
import { isChromeless } from '../atoms/isChromeless';
import { defaultLegalTextUrlMap, legalTextUrlMap } from '../LegalDocUrls';

export const getPrivacyPolicyMarketUrl = ({
  market,
  language,
}: {
  market: MarketCode;
  language: LanguageCode;
}) => {
  // Set default will be the fallback
  let { privacyPolicyUrl } = defaultLegalTextUrlMap;
  const marketLegalUrlMap = legalTextUrlMap[market];

  if (marketLegalUrlMap) {
    if (marketLegalUrlMap.length > 0) {
      privacyPolicyUrl = marketLegalUrlMap[0].privacyPolicyUrl;
    }

    if (checkIsMarketMultilingual(market)) {
      const selectedMarketPP = marketLegalUrlMap.find((el) => el.language === language);

      if (selectedMarketPP?.privacyPolicyUrl) {
        privacyPolicyUrl = selectedMarketPP.privacyPolicyUrl;
      }
    }
  }

  return privacyPolicyUrl;
};

export const PrivacyPolicyMarket = ({
  match,
  history,
  location: { search },
}: RouteComponentProps<{ lang: LanguageCode; market: MarketCode }>) => {
  const { market, lang } = match.params;

  const chromeless = isChromeless(search);

  const onBack = useCallback(() => {
    history.goBack();
  }, [history]);

  const privacyPolicyUrl = getPrivacyPolicyMarketUrl({ market, language: lang });

  if (!privacyPolicyUrl) {
    return <Redirect to="/privacy-policy/en" />;
  }

  return <LegalTemplate onBack={onBack} documentUrl={privacyPolicyUrl} chromeless={chromeless} />;
};
